import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PhoneReportCreate } from '../../../shared/models/phone-report.model';
import { NotificationService } from '../../../shared/services/notification.service';
import { PhoneReportService } from '../../../shared/services/phone-report.service';
import { ValidationService, Validators as Vld } from '../../../shared/services/validation.service';

@Component({
  standalone: false,
  selector: 'app-phone-reports-form',
  templateUrl: './phone-reports-form.component.html',
})
export class PhoneReportsFormComponent implements OnInit {
  @Output() afterSave = new EventEmitter<boolean>();
  @Input() model: PhoneReportCreate;

  issues = [];
  loading = false;
  backButtonShow = false;

  form: FormGroup;

  constructor(
    public notificationService: NotificationService,
    formBuilder: FormBuilder,
    public service: PhoneReportService,
    public validationService: ValidationService
  ) {
    this.model = service.createModel();
    for (const i in service.issues) {
      this.issues.push({ id: i, label: service.issues[i] });
    }
    this.form = formBuilder.group({
      issue: ['', Vld.compose([Vld.required])],
      phone: ['', Vld.compose([Vld.required, Vld.globalPhoneNumber()])],
      description: ['', Vld.compose([Vld.maxLength(255)])],
    });
  }

  ngOnInit() {
    this.model.issue = this.issues[0].id;
    this.form.controls.issue.patchValue(this.issues[0].id);
  }

  copyPhoneNumberToClipboard(): void {
    const phoneNumber = document.getElementById('phoneNumber').innerText;
    navigator.clipboard
      .writeText(phoneNumber)
      .then(() => console.log('Copied to clipboard'))
      .catch(err => console.error('Error copying to clipboard:', err));
  }

  onSubmit() {
    this.loading = true;
    if (this.model.description) {
      this.model.description = this.model.description.trim();
    }

    this.service.create(this.model).subscribe({
      next: res => {
        this.loading = false;
        const successMessage = this.getSuccessMessage(res.status);
        this.notificationService.success(successMessage, 'Phone reports');
        this.afterSave.emit(true);
      },
      error: error => {
        this.loading = false;
        this.notificationService.error({
          title: 'Phone reports',
          message: 'An error occurred while creating report',
          serviceName: 'API GATEWAY',
          requestMessage: error.statusText,
          requestCode: error.status,
        });
      },
    });
  }

  private getSuccessMessage(status: number): string {
    if (this.model.issue === 'PORTED') {
      if (status === 204) {
        return 'Up to date';
      }

      if (status === 200) {
        return 'Thanks for reporting — information has been updated in our system.';
      }
    }

    return 'Report created';
  }
}
